import React from "react";
import { AlertInfo } from "../../../common/Alert";
import BootstrapTable from "react-bootstrap-table-next";
import { FaTrash } from "react-icons/fa";
import { getImage } from "../../../../utils/Utils";
import Empty from "../../../../assets/images_td/appImages/category.png";
import { useAppDispatch, useAppSelector } from "../../../../redux/hook";
import { Color } from "../../../../utils/theme";
import Swal from "sweetalert2";
import {
  CartItemType,
  decrement,
  getCartCount,
  getTotalAmount,
  increment,
  removeCartItem,
} from "../../../../redux/slice/useCartSlice";
import {
  useAddProductCartMutation,
  useDeleteProductCartMutation,
} from "../../../../utils/api/product/product.api";
import { Product } from "../../../../utils/api/product/product.type";
import { formatCurrency  } from "../../../../utils/Utils";
import CartVariationDisplay from "../../../shared/CartVariationDisplay";
import { useShopDevise } from "../../../../catalog/useShopDevise";


function PanierItemTable() {
  const devise = useShopDevise();

  const { user } = useAppSelector((s) => s?.user);
  const [deleteProduct] = useDeleteProductCartMutation();
  // const { data: carts } = useGetCartByUserQuery(user?.slug);
  // const { data, isLoading } = useGetListProductQuery();
  const dispatch = useAppDispatch();
  const { cartItems } = useAppSelector((state) => state.cart);

  const [addToCart] = useAddProductCartMutation();

  const incrementQuantite = (item) => {
    addToCart({
      quantite: 1,
      produit: item?.produit?.id,
      prix: item?.prix,
      variations: item?.variations,
    });
  };

  const decrementQuantite = (item) => {
    addToCart({
      quantite: -1,
      produit: item?.produit?.id,
      prix: item?.prix,
      variations: item?.variations,
    });
  };

  // Fonction pour supprimer un produit du panier
  const supprimerDuPanier = async (produitASupprimer) => {
    await Swal.fire({
      title:
        "Êtes-vous sûr(e) de vouloir supprimer ce produit de votre panier ?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Oui",
      cancelButtonText: "Non",
      showLoaderOnConfirm: true,
      iconColor: Color.themeColor,
      confirmButtonColor: Color.success,
      preConfirm: async () => {
        dispatch(removeCartItem(produitASupprimer));
        dispatch(getCartCount());
        dispatch(getTotalAmount());
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result: any) => {
      // console.log(result, "archiver");

      if (result.isConfirmed) {
        Swal.fire({
          icon: "success",
          title: `Produit supprimé avec succès !`,
          iconColor: Color.success,
          showConfirmButton: false,
          timer: 1500,
        });
      }
    });
  };

  const productFormatter = (cell: Product, row: CartItemType) => {
    let imgProd = "";
    const variation = row?.variations?.[0];
    if (cell?.type === "taille_unique") {
      if (cell?.id) {
        if (cell?.images?.length) {
          imgProd = cell?.images[0]?.image;
        } else {
          imgProd = "";
        }
      }
    } else {
      if (row?.variations?.length) {
        let variation = row?.variations[0];
        if (variation?.images?.length) {
          imgProd = row?.variations[0]?.images[0]?.image;
        } else {
          if (cell?.images?.length) {
            imgProd = cell?.images[0]?.image;
          } else {
            imgProd = "";
          }
        }
      }
    }

    return (
      <div className="d-flex align-items-center gap-2 panier-product-cell-with-actions">
        <div className="product-image-container">
          <img
            loading="lazy"
            src={imgProd ? getImage(imgProd) : Empty}
            alt="image"
            className="cart-image"
          />
        </div>
        <div className="flex-grow-1">
          <p className="product-name-panier mb-1">{cell?.nom}</p>
          <p className="product-category-name mb-0"> {cell?.categorie?.nom}</p>
          <CartVariationDisplay variation={variation} />
        </div>
        <div className="panier-action-delete-inline">
          <button
            type="button"
            className="btn with-tooltip btn-action-icon-delete panier-btn-delete p-0"
            data-tooltip-content="Supprimer"
            onClick={() => supprimerDuPanier(row)}
            aria-label="Supprimer du panier"
          >
            <FaTrash />
          </button>
        </div>
      </div>
    );
  };

  const quantityFormatter = (cell: any, row: any) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <div className="row-quantity">
          {row?.quantite >= 1 && (
            <button
              className="action-btn"
              type="button"
              onClick={() => {
                dispatch(decrement(row));
                dispatch(getCartCount());
                dispatch(getTotalAmount());
              }}
            >
              {" "}
              -
            </button>
          )}
          <span className="col-md-4 qty_wrapper">{row?.quantite}</span>
          {row?.quantite < row?.stock && (
            <button
              type="button"
              className="action-btn"
              onClick={() => dispatch(increment(row))}
            >
              {" "}
              +
            </button>
          )}
        </div>
      </div>
    );
  };

  const totalFormatter = (cell: any, row: any) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        {formatCurrency((row?.prix * row?.quantite), devise)}
      </div>
    );
  };

  const prixFormatter = (cell: any, row: any) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        {formatCurrency(row?.prix, devise)}
      </div>
    );
  };

  const columns = [
    {
      dataField: "produit",
      text: "Produits",
      formatter: productFormatter,
      headerStyle: () => {
        return { width: "45%", minWidth: "280px", whiteSpace: "normal" };
      },
    },
    {
      dataField: "prix",
      text: "Prix",
      formatter: prixFormatter,
      headerStyle: () => {
        return { width: "12%", whiteSpace: "normal" };
      },
    },
    {
      dataField: "quantite",
      text: "Quantité",
      formatter: quantityFormatter,
      headerStyle: () => {
        return { width: "18%", whiteSpace: "normal" };
      },
    },
    {
      dataField: "total",
      text: "Total",
      formatter: totalFormatter,
      headerStyle: () => {
        return { width: "15%", whiteSpace: "normal" };
      },
    },
  ];

  const getItemImage = (row: CartItemType) => {
    const cell = row?.produit;
    if (!cell) return "";
    if (cell?.type === "taille_unique") {
      return cell?.images?.length ? cell.images[0].image : "";
    }
    if (row?.variations?.length && row.variations[0]?.images?.length) {
      return row.variations[0].images[0].image;
    }
    return cell?.images?.length ? cell.images[0].image : "";
  };

  if (!cartItems?.length) {
    return (
      <div className="panier-empty-wrapper">
        <AlertInfo variant="catalog" message="Votre panier est vide" />
      </div>
    );
  }

  return (
    <>
      <div className="panier-table-wrapper no-view-mobile">
        <BootstrapTable
          key={`panier-table-${devise ?? "default"}`}
          keyField="produit.id"
          data={cartItems}
          columns={columns}
          condensed
          hover
          wrapperClasses="table-responsive panier-table"
          noDataIndication={() => (
            <AlertInfo variant="catalog" message="Votre panier est vide" />
          )}
        />
      </div>
      <div className="panier-mobile-list no-view-desktop">
        {(cartItems || []).map((row: CartItemType) => (
          <div key={`mobile-${row?.produit?.id}-${row?.variations?.[0]?.id ?? "u"}`} className="panier-mobile-card">
            <div className="panier-mobile-card-inner">
              <div className="panier-mobile-card-image">
                <img
                  loading="lazy"
                  src={getItemImage(row) ? getImage(getItemImage(row)) : Empty}
                  alt={row?.produit?.nom ?? ""}
                  className="panier-mobile-img"
                />
              </div>
              <div className="panier-mobile-card-body">
                <p className="panier-mobile-name">{row?.produit?.nom}</p>
                <p className="panier-mobile-brand">
                  {row?.produit?.categorie?.nom ? `Marque: ${row.produit.categorie.nom}` : ""}
                </p>
                <CartVariationDisplay
                  variation={row?.variations?.[0]}
                  className="panier-mobile-variation"
                />
                <p className="panier-mobile-price">{formatCurrency(row?.prix ?? 0, devise)}</p>
                <div className="panier-mobile-qty">
                  <div className="row-quantity panier-mobile-row-quantity">
                    {row?.quantite >= 1 && (
                      <button
                        type="button"
                        className="action-btn"
                        onClick={() => {
                          dispatch(decrement(row));
                          dispatch(getCartCount());
                          dispatch(getTotalAmount());
                        }}
                      >
                        -
                      </button>
                    )}
                    <span className="qty_wrapper">{row?.quantite}</span>
                    {row?.quantite < (row?.stock ?? 999) && (
                      <button
                        type="button"
                        className="action-btn"
                        onClick={() => dispatch(increment(row))}
                      >
                        +
                      </button>
                    )}
                  </div>
                </div>
                <p className="panier-mobile-total">
                  {formatCurrency((row?.prix ?? 0) * (row?.quantite ?? 0), devise)}
                </p>
                <div className="panier-mobile-actions">
                  <button
                    type="button"
                    className="btn panier-mobile-btn-delete"
                    onClick={() => supprimerDuPanier(row)}
                    aria-label="Supprimer"
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export default PanierItemTable;
